<template>
    <footer class="bg-black text-center py-5">
            <div class="container px-5">
                <div class="text-white-50 small">
                    <div class="mb-2">&copy; jamye 2025. All Rights Reserved.</div>
                    <div>
                        문의메일: nod15277@gmail.com
                    </div>
                </div>
            </div>
        </footer>
</template>
  
<style>

  footer {
    padding: 100px;
    background-color: #000000;
    color: white;
  }

  
</style>